<template>
  <div class="main-container">
    <TheSideBar>
      <template #default>
        <router-link :to="{name: 'projectsList', params: {status: '$active'}}">
          <i class="fas fa-list"></i>
          Aktivní projekty
        </router-link>
        <router-link v-for="s in activeProjectStates"
                     :key="s.id"
                     :to="{name: 'projectsList', params: {status: s.id}}"
                     class="l1"
        >
          <i class="fas"
             :class="[s.icon]"
             :style="{'color': s.color}"
          ></i>
          {{ s.label }}
        </router-link>
        <router-link :to="{name: 'projectsList', params: {status: '$inactive'}}">
          <i class="fas fa-list"></i>
          Neaktivní projekty
        </router-link>
        <router-link v-for="s in inactiveProjectStates"
                     :key="s.id"
                     :to="{name: 'projectsList', params: {status: s.id}}"
                     class="l1"
        >
          <i class="fas"
             :class="[s.icon]"
             :style="{'color': s.color}"
          ></i>
          {{ s.label }}
        </router-link>
        <router-link :to="{name: 'projectsList', params: {status: '$deleted'}}"
                     class="l1"
        >
          <i class="fas fa-trash"
             style="color: OrangeRed"
          ></i>
          Koš
        </router-link>
        <router-link :to="{name: 'templates'}">
          <i class="fab fa-firstdraft"></i>
          Šablony
        </router-link>
        <hr class="separator" />
        <router-link v-if="$store.getters.currentUserHasAction('ADD_PROJECT')"
                     :to="{name: 'projectsNew'}"
        >
          <i class="fas fa-plus-circle"></i>
          {{ $t('project.new') }}
        </router-link>
        <!-- <router-link v-if="$store.getters.currentUserHasAction('ADD_PROJECT')"
                     :to="{name: 'createProjectFromTemplate'}"
        >
          <i class="fas fa-receipt"></i>
          Projekt ze šablony
        </router-link> -->
        
        <router-link v-if="$store.getters.currentUserHasAction('MANAGE_PROJECT_TYPES')"
                     :to="{name: 'projectTypesList'}"
        >
          <i class="fas fa-list"></i>
          {{ $t('project.type.list') }}
        </router-link>
        <router-link v-if="$store.getters.currentUserHasAction('MANAGE_PROJECT_TYPES')"
                     :to="{name: 'projectTypeNew'}"
        >
          <i class="fas fa-plus-circle"></i>
          {{ $t('project.type.new') }}
        </router-link>
      </template>
    </TheSideBar>
    <DataReady id="content">
      <router-view :key="$route.path"></router-view>
    </DataReady>
  </div>
</template>

<script>
import TheSideBar from 'CORE/components/side-bar/the-side-bar'
import DataReady from 'CORE/components/utilities/data-ready'
import { active as activeStateGroups, inactive as inactiveStateGroups } from 'ENUMS/entity-states-groups'

export default {
    name: 'ProjectsView',
    components: {
        TheSideBar,
        DataReady,
    },
    computed: {
        activeProjectStates() {
            return activeStateGroups
        },
        inactiveProjectStates() {
            return inactiveStateGroups
        },
    },
}
</script>
